import styled from 'styled-components';
export const ContentContainer = styled.div `
  padding: 1.6rem;
  gap: 1.2rem;
  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  display: flex;
  flex-direction: column;

  background: linear-gradient(
      180deg,
      rgba(40, 106, 246, 0.12) 0%,
      rgba(255, 255, 255, 0) 52%,
      rgba(40, 106, 246, 0.12) 100%
    ),
    linear-gradient(
      90deg,
      rgba(40, 106, 246, 0.12) 0.14%,
      rgba(255, 255, 255, 0) 51.5%,
      rgba(40, 106, 246, 0.12) 99.87%
    ),
    var(--Content-on-primary, #fff);
  box-shadow: 0px 20px 24px -4px rgba(0, 0, 0, 0.08),
    0px 8px 8px -4px rgba(0, 0, 0, 0.03);

  ${({ theme }) => theme.media.laptop `
       max-width: 47rem;
  `}
`;
export const DescriptionWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${({ theme }) => theme.media.tablet `
  align-items: flex-start;
  `}
`;
export const DescriptionsSeparator = styled.div `
  height: 1px;
  width: '100%';
  background-color: ${({ theme }) => theme.colors.interactive.secondary};
`;
//# sourceMappingURL=styles.js.map